import { createFileRoute } from '@tanstack/react-router'
import { ProjectFlowView } from '../../components/project-inspector'

export const Route = createFileRoute('/dev/code-graph')({
  component: ProjectFlowView,
})
